export enum PASSWORD_STRENGTH {
  WEAK = 1,
  MODERATE = 2,
  STRONG = 3,
  VERY_STRONG = 4
}
